
import { defineComponent, ref, onMounted } from 'vue'
import Header from './header/Header'
import Auth from './auth/Auth'
import Footer from './footer/Footer'

export default defineComponent({
  methods: {
    resizeWindow () {
      window.dispatchEvent(new Event('resize'))
    }
  },
  setup () {
    const isRaiting = ref<boolean>(false)
    const isAuthorized = ref<string>(localStorage.AuthClient)
    if (isAuthorized.value && location.pathname === '/confirmLogin') location.href = '/'

    onMounted(() => {
      let regex = /\/rating/gm
      isRaiting.value = location.pathname.match(regex) !== null
    })

    return () => {
      return (
        <div class="default-layout">
          <Header/>
          <div class="main-container-content">
            {isAuthorized.value || isRaiting.value
              ? (
                <router-view/>
              )
              : (
                <Auth onAuth={() => { isAuthorized.value = localStorage.AuthClient } }/>
              )
            }
          </div>
          <Footer/>
        </div>
      )
    }
  }
})
